import TableCellNoData from './TableCell';

export default TableCellNoData;